import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class CrmCallService {
  private readonly baseUrl = '/api/crm/calls';

  constructor(
    private httpService: HttpService,
    private constantsService: ConstantsService
  ) {}

  getCalls(from?: string, to?: string): Observable<any> {
    const params: string[] = [];
    if (from) { params.push(`from=${from}`); }
    if (to) { params.push(`to=${to}`); }
    const url = params.length ? `${this.baseUrl}?${params.join('&')}` : this.baseUrl;
    const requestData = {
      API_URL: url,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  createCall(callPayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST,
      BODY: callPayload
    };
    return this.httpService.sendRequest(requestData);
  }

  updateCall(eventId: string, callPayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${encodeURIComponent(eventId)}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_PUT,
      BODY: callPayload
    };
    return this.httpService.sendRequest(requestData);
  }

  cancelCall(eventId: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${encodeURIComponent(eventId)}/cancel`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST
    };
    return this.httpService.sendRequest(requestData);
  }
}
